import first from "./first";
import second from "./second";

export default {
    name: 'realEstate',
    components: {
        first,
        second
    }
}